import { getCzechSuklRsAtcGroupsAutocomplete } from '~/libs/infrastructure/api/availability';

import { SearchAutocompleteItem } from '../components/SearchAutocomplete';
import { buildSlugFromLabel, extractAtcCode, matchSlugCandidate } from './availabilitySlug';

export async function resolveAvailabilitySlugItems(slugs: string[]): Promise<Record<string, SearchAutocompleteItem>> {
	const codes = Array.from(new Set(slugs.map(extractAtcCode).filter(Boolean)));
	const responses = await Promise.all(
		codes.map((filter) => getCzechSuklRsAtcGroupsAutocomplete({ filter, perPage: 100 }))
	);

	const candidates = responses.flatMap((response) =>
		response.items.map((item) => ({
			id: item.id,
			label: item.label,
			slug: buildSlugFromLabel(item.label),
		}))
	);

	return slugs.reduce<Record<string, SearchAutocompleteItem>>((result, requestedSlug) => {
		const match = matchSlugCandidate(requestedSlug, candidates);
		if (match) {
			result[requestedSlug] = match;
		}
		return result;
	}, {});
}
